import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Nav from "../Components/Nav";
import { auth, db } from "../config";
import { doc, getDoc, addDoc,updateDoc, collection, getDocs, query, where } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

function ProfitTracker() {
  const [user, setUser] = useState(null);
  const [balance, setBalance] = useState(0);
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [mt4Form, setMt4Form] = useState({
    duration: "default",
    amount: "",
    userid: "",
    pswrd: "",
    acntype: "",
    currency: "",
    leverage: "",
    server: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        try {
          // Fetch user balance
          const userDocRef = doc(db, "users", currentUser.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            setBalance(userDoc.data().balance || 0);
          }

          // Fetch user investments
          const investmentsQuery = query(
            collection(db, "investments"),
            where("userId", "==", currentUser.uid)
          );
          const querySnapshot = await getDocs(investmentsQuery);
          const fetchedInvestments = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setInvestments(fetchedInvestments);
        } catch (error) {
          console.error("Error fetching data:", error);
          setMessage("Error fetching data.");
        } finally {
          setLoading(false);
        }
      } else {
        setUser(null);
        navigate("/auth/login");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const calcAmount = (duration) => {
    const amounts = {
      Monthly: 100,
      Quaterly: 250,
      Yearly: 900,
    };
    return amounts[duration] || "";
  };

  const handleMt4Submit = async (e) => {
    e.preventDefault();
    if (!user) {
      setMessage("User not authenticated.");
      return;
    }

    const { duration, userid, pswrd, acntype, currency, leverage, server } = mt4Form;

    if (duration === "default" || !userid || !pswrd || !acntype || !currency || !leverage || !server) {
      setMessage("All fields are required.");
      return;
    }

    const amount = calcAmount(duration);
    if (!amount) {
      setMessage("Invalid subscription duration.");
      return;
    }

    if (amount > balance) {
      setMessage("Insufficient balance for subscription.");
      return;
    }

    setSubmitting(true);
    try {
      // Save MT4 details to Firestore
      await addDoc(collection(db, "mt4Subscriptions"), {
        userId: user.uid,
        email: user.email,
        duration,
        amount,
        userid,
        pswrd,
        acntype,
        currency,
        leverage,
        server,
        createdAt: new Date(),
        status: "pending",
      });

      // Deduct amount from user balance
      const userDocRef = doc(db, "users", user.uid);
      const newBalance = balance - amount;
      await updateDoc(userDocRef, { balance: newBalance });
      setBalance(newBalance);

      setMessage("MT4 subscription submitted successfully!");
      setMt4Form({
        duration: "default",
        amount: "",
        userid: "",
        pswrd: "",
        acntype: "",
        currency: "",
        leverage: "",
        server: "",
      });
      // Close modal
      const modal = window.bootstrap.Modal.getInstance(document.getElementById("submitmt4modal"));
      modal.hide();
    } catch (error) {
      console.error("Error submitting MT4 subscription:", error);
      setMessage("Error submitting MT4 subscription: " + error.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMt4Form((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "duration" && { amount: calcAmount(value) }),
    }));
  };


  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>TRUE LEDGER ASSIST | Profit Tracker</title>
        <link
          rel="icon"
          href="https://trueledgerassist.com/auth/storage/app/public/photos/IQAXeGtikmark.png1744508352"
          type="image/png"
        />
      </Helmet>

      <style>
        {`
          .custom-select {
            display: inline-block;
            max-width: 100%;
            height: calc(2.25rem + 2px);
            padding: .375rem 1.75rem .375rem .75rem;
            line-height: 1.5;
            color: #0b57e3;
            vertical-align: middle;
            background: #fff url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center;
            background-size: 8px 10px;
            border: 4px solid black;
            border-radius: .25rem;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }
          .custom-select:focus {
            border-color: #80bdff;
            outline: 0;
          }
          .custom-select:disabled {
            color: #868e96;
            background-color: #e9ecef;
          }
          .footer-block {
            min-height: 400px;
            padding: 50px 0;
            background: linear-gradient(to right, #212529, #131516), url(../img/project4.jpg);
          }
          .foot-header {
            font-family: "Montserrat", Sans-serif;
            font-weight: 600;
            font-size: 1rem;
            margin-bottom: 25px;
            color: #4A4A4A;
          }
          .foot {
            display: block;
            font-size: small;
            margin-bottom: 8px;
            font-family: "Montserrat", Sans-serif;
            color: #A1A39E !important;
          }
          .foot:hover {
            text-decoration: none !important;
            color: #FE413C !important;
          }
          .foot::before {
            content: "-";
            margin-right: 3px;
            color: #FE413C;
          }
          .footer-credit {
            font-family: "Montserrat", Sans-serif;
            color: #FE413C;
            font-size: small;
          }
          .footer-block .small-image {
            width: 250px;
            height: auto;
          }
          .table-responsive {
            overflow-x: auto;
          }
          .table th, .table td {
            vertical-align: middle;
            text-align: left;
          }
          .message {
            margin-top: 15px;
            padding: 10px;
            border-radius: 5px;
          }
          .message.success {
            background-color: #d4edda;
            color: #155724;
          }
          .message.error {
            background-color: #f8d7da;
            color: #721c24;
          }
        `}
      </style>

      <div className="wrapper">
        <Nav />
        <div className="main-panel bg-light">
          <div className="content bg-light">
            <div className="page-inner">
              <div className="mt-2 mb-4">
                <h1 className="title1 text-dark">Your ROI History</h1>
                <p className="text-dark">Available Balance: ${balance.toFixed(2)}</p>
                {message && (
                  <div className={`message ${message.includes("success") ? "success" : "error"}`}>
                    {message}
                  </div>
                )}
              </div>
              <div className="mb-5 row">
                <div className="col card shadow-lg bg-light p-3">
                  <div className="table-responsive">
                    <table id="UserTable" className="table table-hover text-dark">
                      <thead>
                        <tr>
                          <th>Plan</th>
                          <th>Amount</th>
                          <th>ROI</th>
                          <th>Duration</th>
                          <th>Status</th>
                          <th>Date Created</th>
                        </tr>
                      </thead>
                      <tbody>
                        {investments.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No investments found.
                            </td>
                          </tr>
                        ) : (
                          investments.map((investment) => (
                            <tr key={investment.id}>
                              <td>{investment.plan}</td>
                              <td>${investment.amount.toFixed(2)}</td>
                              <td>{investment.roi}%</td>
                              <td>{investment.duration}</td>
                              <td>
                                <span
                                  style={{
                                    color:
                                      investment.status === "active"
                                        ? "#28a745"
                                        : investment.status === "pending"
                                        ? "#ffc107"
                                        : "#dc3545",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {investment.status.charAt(0).toUpperCase() +
                                    investment.status.slice(1)}
                                </span>
                              </td>
                              <td>
                                {new Date(investment.createdAt.seconds * 1000).toLocaleDateString()}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#submitmt4modal"
                    >
                      Subscribe to Trading
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="footer-block">
              <div className="container">
                <div className="row">
                  <div className="col-6 col-md-4 mb-3 mb-md-0">
                    <div className="foot-header">Company</div>
                    <div className="foot-body">
                      <a href="/dashboards/buy-plan" className="foot">
                        Investment Plans
                      </a>
                      <a href="/about.html" className="foot">About Us</a>
                      <a
                        href="https://www.google.com/maps?ll=-27.382143,152.993196&z=9&t=m&hl=en&gl=NG&mapclient=embed&q=Brisbane+Queensland+Australia"
                        className="foot"
                      >
                        <b>Australia Address:</b> Brisbane
                      </a>
                      <a href="/contact.html" className="foot">Contact us</a>
                    </div>
                  </div>
                  <div className="col-6 col-md-2 mb-3 mb-md-0">
                    <div className="foot-header">Platforms</div>
                    <div className="foot-body">
                      <a href="https://trueledgerassist.com/auth/login" className="foot">
                        Platforms
                      </a>
                      <a href="https://trueledgerassist.com/auth/login" className="foot">
                        MT4 for Windows
                      </a>
                      <a href="https://trueledgerassist.com/auth/login" className="foot">
                        MT4 for iOS
                      </a>
                      <a href="https://trueledgerassist.com/auth/login" className="foot">
                        MT4 for Android
                      </a>
                      <a
                        href="https://mine.mql5.com/mine?servers=-Demo%2CprimeMiningNetwork-Live&mine_server=primeMiningNetwork-Demo&demo_server=primeMiningNetwork-Demo&startup_mode=open_demo&lang=en"
                        className="foot"
                      >
                        Web miner
                      </a>
                    </div>
                  </div>
                  <div className="col-6 col-md-2 mb-3 mb-md-0">
                    <div className="foot-header">Trading</div>
                    <div className="foot-body">
                      <a href="https://trueledgerassist.com/auth/register" className="foot">
                        Open Live Account
                      </a>
                      <a href="https://trueledgerassist.com/auth/login" className="foot">
                        Instruments
                      </a>
                      <a href="https://trueledgerassist.com/auth/login" className="foot">
                        Leaderboard
                      </a>
                      <a href="https://trueledgerassist.com/auth/login" className="foot">
                        Market Analysis
                      </a>
                    </div>
                  </div>
                  <div className="col-6 col-md-2 mb-3 mb-md-0">
                    <div className="foot-header">Funding</div>
                    <div className="foot-body">
                      <a href="https://trueledgerassist.com/auth/login" className="foot">
                        Funding Methods
                      </a>
                      <a href="https://trueledgerassist.com/auth/login" className="foot">
                        Clients Protection
                      </a>
                    </div>
                  </div>
                  <div className="col-6 col-md-2 mb-3 mb-md-0">
                    <div className="foot-header">Legal</div>
                    <div className="foot-body">
                      <a href="#" className="foot">AML Policy</a>
                      <a href="#" className="foot">Cookie Policy</a>
                      <a href="#" className="foot">Privacy Policy</a>
                      <a href="/faq.html" className="foot">Risk Disclosure</a>
                      <a href="/terms.html" className="foot">Terms & Conditions</a>
                    </div>
                  </div>
                </div>
                <div className="text-center mt-5">
                  <img src="/home/logo-payments.png" className="small-image" alt="Payment Methods" />
                </div>
                <div className="text-center mt-4">
                  <p className="footer-credit">©2024, TRUE LEDGER ASSIST - ALL RIGHTS RESERVED.</p>
                </div>
                <div className="text-center mt-4">
                  <div className="d-flex justify-content-center col-5 col-lg-3">
                    <div>
                      <img src="/home/award001.png" width="80%" alt="Award 1" />
                    </div>
                    <div>
                      <img src="/home/award002.png" width="80%" alt="Award 2" />
                    </div>
                    <div>
                      <img src="/home/award003.png" width="80%" alt="Award 3" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                position: "fixed",
                left: 0,
                bottom: 0,
                zIndex: 1,
                width: "100%",
              }}
            >
              <div
                style={{
                  width: "100%",
                  backgroundColor: "#FFFFFF",
                  overflow: "hidden",
                  boxSizing: "content-box",
                  textAlign: "right",
                  lineHeight: "14px",
                  fontSize: "12px",
                  fontFeatureSettings: "normal",
                  textSizeAdjust: "100%",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                <div style={{ height: "40px" }}>
                  <iframe
                    src="https://widget.coinlib.io/widget?type=horizontal_v2&theme=light&pref_coin_id=1505&invert_hover="
                    width="100%"
                    height={36}
                    scrolling="auto"
                    marginWidth={0}
                    marginHeight={0}
                    frameBorder={0}
                    border={0}
                    style={{ border: 0, margin: 0, padding: 0 }}
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfitTracker;
